import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, Form, Radio, Button, message, Modal, Input, Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { UPLOADS, IMAGES } from '../../params';
import { getSurveysList } from '../../API/surveys';
import { Error404_Component } from "../errors/404";
import { setSurveys_id } from "../../redux/surveys/reducer";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { TbReload } from "react-icons/tb";
SwiperCore.use([Autoplay, Navigation, Pagination]);

import edjsParser from 'editorjs-parser';
const parser = new edjsParser();
import parse from 'html-react-parser';

export const Checkup_health = props => {
    
    const dispatch = useDispatch();
    const history = useHistory()
    const app_global = useSelector(state => state.app_global);
    const profile = useSelector(state => state.profile);
    const surveys = useSelector(state => state.surveys);
    
    const [form_surveys_passing] = Form.useForm();
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const navigationPrev_2_Ref = React.useRef(null)
    const navigationNext_2_Ref = React.useRef(null)

    const [activeReview, setActiveReview] = useState(1);
    const [activeReviewResult, setActiveReviewResult] = useState(0);
    const [activeReview_count, setActiveReview_count] = useState(1);

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    useEffect(async () => {
        component_start()
    }, [profile.token]);

    async function component_start() {
        
        dispatch(setSurveys_id({}));

        await getSurveysList({
            category: 1
        },dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getSurveysList]`, `color: #A366FF`, json );
            if (json?.code) {
                //Done
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });

        let window_location_search = window.location.search;
        let urlParams = new URLSearchParams(window_location_search);
        let paramAnswer = urlParams.get('answer');
        if (paramAnswer) {
            let data = paramAnswer.split('_');
            let id = data[0];
            let type = data[1];

            if (type === 'review') {
                if (list_review.find(item => item.id === +id) !== undefined) {
                    setActiveReview(+id);
                    setActiveReview_count(activeReview_count+1);
                }
            }
            const params = new URLSearchParams();
            params.delete("answer");
            history.push({search: params.toString()});
        }
    }

    var obj = {
        get surveys_list () {
            return surveys.surveys_list.slice(0, 4);
        },
    };

    // Отправка формы результата опроса
    async function form_finish_surveys_passing(v) {
        console.log(v);
    }

    const list_review = [
        {
            id: 1,
            label: 'Выберите пол',
            excerpt: null,
            answers: [
                {
                    label: 'Мужчина',
                    value: '2_review'
                },
                {
                    label: 'Женщина',
                    value: '3_review'
                }
            ],
        },
        {
            id: 2,
            label: 'Укажите свой возраст',
            excerpt: null,
            answers: [
                {
                    label: 'до 30 лет',
                    value: '1_result'
                },
                {
                    label: 'от 30 до 40 лет',
                    value: '2_result'
                },
                {
                    label: 'больше 40 лет',
                    value: '3_result'
                }
            ],
        },
        {
            id: 3,
            label: 'Выберите категорию, подходящую Вам',
            excerpt: null,
            answers: [
                {
                    label: 'Ежегодные анализы для женщин',
                    value: '4_review'
                },
                {
                    label: 'Анализы для беременных',
                    value: '5_review'
                }
            ],
        },
        {
            id: 4,
            label: 'Выберите возрастную категорию',
            excerpt: null,
            answers: [
                {
                    label: 'Женщины до 40 лет',
                    value: '4_result'
                },
                {
                    label: 'Женщины старше 40 лет',
                    value: '5_result'
                }
            ],
        },
        {
            id: 5,
            label: 'Анализы для беременных',
            excerpt: null,
            answers: [
                {
                    label: 'Анализы для первого триместра',
                    value: '6_result'
                },
                {
                    label: 'Анализы для второго триместра',
                    value: '7_result'
                },
                {
                    label: 'Анализы для третьего триместра',
                    value: '8_result'
                }
            ],
        },
    ];

    const list_review_result = [
        {
            id: 1,
            label: 'Ежегодные анализы для мужчин до 30 лет',
            excerpt: null,
            warning: null,
            list: [
                'Общий анализ крови и мочи',
                'Выявление уровня содержания глюкозы в крови',
                'Биохимический анализ крови',
                'Липидограмма',
                'Анализ на ВИЧ, сифилис и гепатит B',
                'Анализ на тестостерон',
                'Онкомаркеры (ПСА общий, ПСА свободный)',
                'Тест на скрытую кровь в кале',
                'Анализ на тиреотропный гормон',
                'ЭКГ',
                'ЭХО КГ (УЗИ сердца)',
                'УЗИ брахиоцефальных артерий',
                'УЗИ органов малого таза (трансректальное) и наружных половых органов',
                'УЗИ органов брюшной полости и почек, надпочечников',
                'УЗИ щитовидной железы',
            ]
        },
        {
            id: 2,
            label: 'Ежегодные анализы для мужчин от 30 до 40 лет',
            excerpt: null,
            warning: null,
            list: [
                'Общий анализ крови',
                'Общий анализ мочи',
                'Биохимический анализ крови',
                'Липидограмма',
                'Анализ на выявление инфекций (ВИЧ, сифилис, гепатит В)',
                'Тиреотропный гормон',
                'Тестостерон',
                'Простатический специфический антиген (сокр. ПСА)',
                'Тест на скрытую кровь в кале',
                'ЭКГ',
                'ЭХО КГ (УЗИ сердца)',
                'УЗИ брахиоцефальных артерий',
                'УЗИ органов малого таза (трансректальное) и наружных половых органов',
                'УЗИ органов брюшной полости и почек, надпочечников',
                'УЗИ щитовидной железы',
                'Низкодозная КТ легких',
            ]
        },
        {
            id: 3,
            label: 'Диагностика здоровья для  мужчин после 40 лет',
            excerpt: null,
            warning: null,
            list: [
                'Общий и биохимический анализ крови',
                'Общий анализ мочи',
                'Анализ на простатический антиген',
                'Анализ на уровень тестостерона',
                'Анализ на уровень гормона щитовидной железы',
                'Анализ на уровень витаминов и минералов',
                'Анализ на уровень мочевой кислоты',
                'Анализ крови на уровень глюкозы',
                'ЭКГ',
                'УЗИ малого таза (трансабдоминальное) и наружных половых органов',
                'УЗИ органов брюшной полости и почек, надпочечников',
                'УЗИ щитовидной железы',
                'Низкодозная КТ легких',
            ]
        },
        {
            id: 4,
            label: 'Анализы, необходимые ежегодно сдавать  женщинам до 40 лет',
            excerpt: null,
            warning: null,
            list: [
                'Общий анализ мочи',
                'Общий и развернутый биохимический анализы крови',
                'Анализы на уровень витамина D и ферритина',
                'УЗИ молочных желез',
                'УЗИ щитовидной железы',
                'УЗИ органов малого таза',
                'Цитология шейки матки',
                'Кардиограмма',
                'Липидограмма',
                'Анализы на ВИЧ, сифилис, гепатит В',
                'Флюорография (раз в 2–3 года)',
                'Гинекологический мазок (каждые 6 мес)',
            ]
        },
        {
            id: 5,
            label: 'Анализы, необходимые сдавать каждый год женщинам после 40 лет',
            excerpt: null,
            warning: null,
            list: [
                'Общий анализ мочи',
                'Общий и развернутый биохимический анализы крови',
                'Анализы на уровень витамина D и ферритина',
                'УЗИ молочных желез',
                'УЗИ щитовидной железы',
                'УЗИ органов малого таза',
                'Цитология шейки матки',
                'Кардиограмма',
                'Липидограмма',
                'Анализы на ВИЧ, сифилис, гепатит В',
                'Флюорография (раз в 2–3 года)',
                'Гинекологический мазок (каждые 6 мес)',
                'Анализ на гормоны (фолликулостимулирующий и эстрадиол)',
                'Анализ на общий кальций',
                'Исследование кала на скрытую кровь',
                'Наличие онкомаркеров СА-125 и СА 15-3',
                'УЗИ сердца',
                'УЗИ брахиоцефальных артерий',
            ]
        },
        {
            id: 6,
            label: 'Анализы для беременных',
            excerpt: 'Первый триместр (0-14 недель)',
            warning: 'На учет в женскую консультацию женщины обязаны встать до срока 12 недель. На первичном приеме врач-гинеколог проведет осмотр, соберет анамнез и назначит анализы крови.',
            list: [
                'Общий анализ мочи',
                'Биохимический анализ крови',
                'Анализ на антитела классов M, G к вирусам краснухи, герпеса, цитомегаловирусу, а также токсоплазме (TORCH-панель)',
                'Коагулограмма',
                'Анализ на группу крови, резус-фактор',
                'Анализ на сифилис, гепатит B и C, ВИЧ',
                'Анализ на сахар, на толерантность к глюкозе',
                'Двойной тест (РАРР-А+ХГЧ). Позволяет обнаружить такие патологии, как синдромы Эдвардса, Патау, Дауна',
                'ПЦР на хламидии, гонококки, микоплазму',
                'Микроскопическое исследование влагалищных выделений',
            ]
        },
        {
            id: 7,
            label: 'Анализы для беременных',
            excerpt: 'Второй триместр (14-26 недель)',
            warning: 'На учет в женскую консультацию женщины обязаны встать до срока 12 недель. На первичном приеме врач-гинеколог проведет осмотр, соберет анамнез и назначит анализы крови.',
            list: [
                'Общий анализ мочи',
                'Тест на резус-антитела (в случае если резус-фактор у родителей отличаются)',
                'Тройной тест (бета-ХГ + АПФ + эстриол) - на 16-18 неделях',
                'Посев средней порции мочи',
            ]
        },
        {
            id: 8,
            label: 'Анализы для беременных',
            excerpt: 'Третий триместр (27-40 недель)',
            warning: 'На учет в женскую консультацию женщины обязаны встать до срока 12 недель. На первичном приеме врач-гинеколог проведет осмотр, соберет анамнез и назначит анализы крови.',
            list: [
                'Общий и биохимический анализ крови',
                'Анализ мочи',
                'Коагулограмма',
                'TORCH-панель',
                'На гепатит B и C, сифилис, ВИЧ',
                'ПГТТ (пероральный глюкозотолерантный тест)',
                'Микроскопическое исследование влагалищных выделений',
            ]
        }
    ];

    const active_review = list_review.find(item => item.id === activeReview);
    const active_review_result = list_review_result.find(item => item.id === activeReviewResult) ? list_review_result.find(item => item.id === activeReviewResult) : {};

    function review_change(e) {
        let data = e.target.value.split('_');
        let id = data[0];
        let type = data[1];

        if (type === 'result') {
            setActiveReviewResult(+id);
        } else {
            setActiveReview(+id);
            setActiveReview_count(activeReview_count+1);
        }
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <section className='container_full --checkup_health'>
                        <section className='top'>
                            <section className='container shadow default_padding'>
                                <h1>Check Up здоровья</h1>
                            </section>
                        </section>
                        <section className='body'>
                            <section className='container shadow default_padding'>
                                <section className='left'>
                                    <p className='title'>Рекомендуемые опросы</p>
                                    <p className='excerpt'>Так же вы можете пройти другие опросы на нашем портале, чтобы понять узнать текущее состояние вашего здоровья</p>
                                    {obj.surveys_list ? 
                                        <>
                                            <div className='slider_pc'>
                                            {
                                                obj.surveys_list.map((item) => 
                                                    <Link to={`/surveys/${item?.id}`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                        <div className='article_background'>
                                                            <img src={`${UPLOADS}/${item.photo_mini}`} />
                                                        </div>
                                                        <div className='article_column'>
                                                            <div className='article_column_left'>
                                                                <div className='article_title'>{item?.seo_title}</div>
                                                                <div className='article_excerpt'>{item?.excerpt}</div>
                                                            </div>
                                                            <div className='article_column_right'>
                                                                <span></span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                )
                                            }
                                            </div>
                                            <div className='slider_mob'>
                                                <Swiper
                                                    loop
                                                    spaceBetween={12}
                                                    slidesPerView={1.5}
                                                    pagination={{
                                                        type: "progressbar",
                                                    }}
                                                    navigation={{
                                                        prevEl: navigationPrevRef.current,
                                                        nextEl: navigationNextRef.current,
                                                    }}
                                                    onBeforeInit={(swiper) => {
                                                        swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                        swiper.params.navigation.nextEl = navigationNextRef.current;
                                                    }}
                                                    breakpoints={{
                                                        992: {
                                                            slidesPerView: 2.75,
                                                        },
                                                        991: {
                                                            slidesPerView: 2,
                                                        },
                                                        700: {
                                                            slidesPerView: 1.5,
                                                        },
                                                    }}
                                                >
                                                    {
                                                        surveys.surveys_list.slice(0, 4).map((item) => 
                                                            <SwiperSlide>
                                                                <Link to={`/surveys/${item?.id}`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                                    <div className='article_background'>
                                                                        <img src={`${UPLOADS}/${item.photo_mini}`} />
                                                                    </div>
                                                                    <div className='article_column'>
                                                                        <div className='article_column_left'>
                                                                            <div className='article_title'>{item?.seo_title}</div>
                                                                            <div className='article_excerpt'>{item?.excerpt}</div>
                                                                        </div>
                                                                        <div className='article_column_right'>
                                                                            <span></span>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            </SwiperSlide>
                                                        )
                                                    }
                                                </Swiper>
                                            </div>
                                        </>
                                    :
                                        <div className='article'>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'><Skeleton.Button style={{marginBottom: '5px', maxWidth: '200px'}} size="small" shape="round" active block /></div>
                                                    <div className='article_excerpt'><Skeleton.Button style={{marginBottom: '5px', maxWidth: '150px'}} size="small" shape="round" active block /></div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </section>
                                <section className='right'>
                                    <div className='content'>
                                        <div className='header'>
                                            <div className='posts_image_big'>
                                                <img src={`${IMAGES}/banners/checkup_health.jpg`} />
                                            </div>
                                        </div>

                                        <div className='body'>
                                            <div className='text_content'>
                                                <p>Почему важно проходить ежегодное обследование организма? Ежегодное обследование организма имеет ряд важных преимуществ.</p>
                                                <p>В первую очередь, это позволяет оценить общее состояние организма и выявить органы, которые могут требовать лечения. Более того, регулярное обследование помогает обнаружить болезни на ранних этапах, что повышает шансы на успешное лечение и восстановление здоровья.Чтобы получить наиболее полную информацию о состоянии своего организма, рекомендуется включать в ежегодное профилактическое обследование определенный набор анализов, который покрывает все системы организма. На нашем портале Вы можете ознакомиться с полным перечнем анализов, необходимых для максимально объемного обследования.</p>
                                            </div>

                                            <div className='review_container'>
                                                <div className='list'>
                                                    <div className='review_header'>
                                                        <h2>
                                                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M20.912 14.8L19.472 16.272C18.32 17.424 17.6 18.4 17.6 20.8H14.4V20C14.4 18.224 15.12 16.624 16.272 15.472L18.256 13.456C18.848 12.88 19.2 12.08 19.2 11.2C19.2 10.3513 18.8629 9.53737 18.2627 8.93726C17.6626 8.33714 16.8487 8 16 8C15.1513 8 14.3374 8.33714 13.7373 8.93726C13.1371 9.53737 12.8 10.3513 12.8 11.2H9.6C9.6 9.50261 10.2743 7.87475 11.4745 6.67452C12.6747 5.47428 14.3026 4.8 16 4.8C17.6974 4.8 19.3253 5.47428 20.5255 6.67452C21.7257 7.87475 22.4 9.50261 22.4 11.2C22.3977 12.5492 21.8629 13.8429 20.912 14.8ZM17.6 27.2H14.4V24H17.6M16 0C13.8989 0 11.8183 0.413852 9.87706 1.21793C7.93586 2.022 6.17203 3.20055 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C6.17203 28.7994 7.93586 29.978 9.87706 30.7821C11.8183 31.5861 13.8989 32 16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 7.152 24.8 0 16 0Z" fill="#487CAB"/>
                                                            </svg>
                                                            <span>Вопрос {activeReview_count}</span>
                                                        </h2>
                                                        <Button className='submit_mini' onClick={() => {setActiveReview(1);setActiveReviewResult(0);setActiveReview_count(1)}}><TbReload /><span>Начать опрос заново</span></Button>
                                                    </div>
                                                    <div className='body'>
                                                        <p>{active_review.label}</p>
                                                        {
                                                            <Radio.Group onChange={(e) => review_change(e)} disabled={activeReviewResult} className='custom_radio' options={active_review.answers} optionType="button" />
                                                        }
                                                        <span></span>
                                                        <div></div>
                                                    </div>
                                                </div>
                                                <div className='result'>
                                                    <h2>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_734_2021)">
                                                            <path d="M23.5013 17.9972L15.0233 2.41243C13.6612 0.119256 10.3407 0.116209 8.9767 2.41243L0.499073 17.9972C-0.893396 20.3405 0.792463 23.3078 3.52167 23.3078H20.478C23.2049 23.3078 24.8938 20.3429 23.5013 17.9972ZM12 20.4953C11.2248 20.4953 10.5937 19.8642 10.5937 19.089C10.5937 18.3138 11.2248 17.6828 12 17.6828C12.7752 17.6828 13.4062 18.3138 13.4062 19.089C13.4062 19.8642 12.7752 20.4953 12 20.4953ZM13.4062 14.8703C13.4062 15.6455 12.7752 16.2765 12 16.2765C11.2248 16.2765 10.5937 15.6455 10.5937 14.8703V7.83901C10.5937 7.06379 11.2248 6.43276 12 6.43276C12.7752 6.43276 13.4062 7.06379 13.4062 7.83901V14.8703Z" fill="#487CAB"/>
                                                            </g>
                                                            <defs>
                                                            <clipPath id="clip0_734_2021">
                                                            <rect width="24" height="24" fill="white"/>
                                                            </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <span>Результат опроса</span>
                                                    </h2>
                                                    {!activeReviewResult ? 
                                                        <div className='body dashed'>
                                                            <img src={`${IMAGES}/banners/checkup_health_result.svg`} />
                                                            <p>После завершения теста Вы получите рекомендации по дальнейшему обследованию, основанные на его результатах</p>
                                                        </div>
                                                    :
                                                        <>
                                                            <div className='body'>
                                                                <p className='title'>{active_review_result?.label}</p>
                                                                {active_review_result?.excerpt ? 
                                                                    <p className='excerpt'>{active_review_result?.excerpt}</p>
                                                                :
                                                                    null
                                                                }
                                                                <ul>
                                                                    {active_review_result?.list.map((item, index) => 
                                                                        <li>{item}</li>
                                                                    )}
                                                                </ul>
                                                            </div>
                                                            {active_review_result?.warning ? 
                                                                <>
                                                                    <div className='review_header'>
                                                                        <h2>
                                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <g clip-path="url(#clip0_734_2021)">
                                                                                <path d="M23.5013 17.9972L15.0233 2.41243C13.6612 0.119256 10.3407 0.116209 8.9767 2.41243L0.499073 17.9972C-0.893396 20.3405 0.792463 23.3078 3.52167 23.3078H20.478C23.2049 23.3078 24.8938 20.3429 23.5013 17.9972ZM12 20.4953C11.2248 20.4953 10.5937 19.8642 10.5937 19.089C10.5937 18.3138 11.2248 17.6828 12 17.6828C12.7752 17.6828 13.4062 18.3138 13.4062 19.089C13.4062 19.8642 12.7752 20.4953 12 20.4953ZM13.4062 14.8703C13.4062 15.6455 12.7752 16.2765 12 16.2765C11.2248 16.2765 10.5937 15.6455 10.5937 14.8703V7.83901C10.5937 7.06379 11.2248 6.43276 12 6.43276C12.7752 6.43276 13.4062 7.06379 13.4062 7.83901V14.8703Z" fill="#487CAB"/>
                                                                                </g>
                                                                                <defs>
                                                                                <clipPath id="clip0_734_2021">
                                                                                <rect width="24" height="24" fill="white"/>
                                                                                </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                            <span>Внимание</span>
                                                                        </h2>
                                                                    </div>
                                                                    <p>{active_review_result?.warning}</p>
                                                                </>
                                                            :
                                                                null
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </section>
                </>
            }
        </>
    );
};